module.exports = __webpack_public_path__ + "5c138de9dbdad3b10c8d43cfcd741900.png";